/*
 * @Descripttion: 
 * @version: 
 * @Author: TangXihao
 * @Date: 2021-01-25 14:47:15
 * @LastEditors: TangXihao
 * @LastEditTime: 2021-07-30 08:58:52
 */
export function transformtime(data, format = "") {
    var dt = new Date(data);
    var y = dt.getFullYear();
    var m = (dt.getMonth() + 1).toString().padStart(2, "0");
    var d = dt.getDate().toString().padStart(2, "0");
    var h = dt.getHours().toString().padStart(2, "0");
    var mm = dt.getMinutes().toString().padStart(2, "0");
    var s = dt.getSeconds().toString().padStart(2, "0");

    // let current = new Date()
    // var cy = current.getFullYear();
    // var cm = (current.getMonth() + 1).toString().padStart(2, "0");
    // var cd = current.getDate().toString().padStart(2, "0");

    // let dy = cy - y
    // let dm = cm - m
    // let dd = cd - d

    if (format === 'yyyy-mm-dd') {
        return `${y}-${m}-${d}`
    }
    if (format === 'hh:mm:ss') {
        return `${h}:${mm}:${s}`
    }
    if (format === 'yyyy-mm-dd hh:mm:ss') {
        return `${y}-${m}-${d} ${h}:${mm}:${s}`
    }
    return `${y}/${m}/${d} ${h}:${mm}:${s}`
}
export function transformtimesimple(data) {
    var dt = new Date(data);
    var y = dt.getFullYear();
    var m = (dt.getMonth() + 1).toString().padStart(2, "0");
    var d = dt.getDate().toString().padStart(2, "0");
    var h = dt.getHours().toString().padStart(2, "0");
    var mm = dt.getMinutes().toString().padStart(2, "0");
    var s = dt.getSeconds().toString().padStart(2, "0");

    let current = new Date()
    var cy = current.getFullYear();
    var cm = (current.getMonth() + 1).toString().padStart(2, "0");
    var cd = current.getDate().toString().padStart(2, "0");

    let dy = cy - y
    let dm = cm - m
    let dd = cd - d

    if (dy != 0) {
        return `${y}-${m}-${d}`.substring(2)
    }
    if (dm != 0 || dd != 0) {
        return `${m}-${d}`
    }
    return `${h}:${mm}`
}
/**
 * 
 * @param {*} content 输出内容
 * @param {*} type 类型（start/end）
 */
export function customlog(content, type) {
    let text = content 
    if (type === 'start') {
        text='>>>>>>'+text
    } else if (type === 'end') {
        text=text+'<<<<<<'
    }
    
    text+= "-----"+transformtime(new Date())
}

export function standardSize(bytes,fixed=2){
    if(!bytes){
        return 0
    }
    let res= bytes < 1000 ? bytes + 'Byte' : bytes < 1000 * 1024 ? ((bytes / 1024).toFixed(fixed) + 'KB') : bytes < 1000 * 1024 * 1024 ? ((bytes / 1000 / 1024).toFixed(fixed) + 'MB') : ((bytes / 1000 / 1024 / 1024).toFixed(fixed) + 'GB')
    return res
}

export function getBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}